import { config } from "../../utils/constants";
import axios from "axios";

export const getHeadlthCardInfo = () => {
  const requestConfig = {
    url: `${config.renewHealthService}healthCardInfo`,
    headers: {
      'Accept': 'application/json'
    },
    method: "GET"
  };

  return axios.request(requestConfig);
};

export const getPlanDetails = (code) => {
  return axios.request({
    url: `${config.renewHealthService}planDetails?code=${code}`,
    headers: {
      'Accept': 'application/json'
    },
    method: "GET"
  });
};

export const getDigitalCardData = () => {
  return axios.request({
    url: `${config.renewHealthService}digitalCardData`,
    headers: {
      'Accept': 'application/json'
    },
    method: "GET"
  });

};

export const getDownloadPdf = (data) => {
  return axios.request({
    url: `${config.renewHealthService}downloadHealthCard`,
    headers: {
      'Accept': 'application/json'
    },
    method: "POST",
    data
  });

};